<ng-container *ngIf="!phxInline">
  <ng-container
    *ngTemplateOutlet="phxDatePickerToggleEnabled && isMobileView ? mobileViewSelector : desktopViewSelector"
  ></ng-container>
  <ng-template #desktopViewSelector>
    <div
      class="phx-date-picker-trigger"
      [phxDropdownFor]="overlay"
      [phxPosition]="'bottomLeft'"
      [phxBackdrop]="true"
      [(phxVisible)]="phxOpen"
      [phxClickHide]="!phxMultiple"
      [phxDropdownOffset]="phxDropdownOffset"
      phxDropdownClassName="phx-date-picker-overlay-pane"
      (phxVisibleChange)="onDropdownToggle($event)"
      [phxDisabled]="phxDisabled"
    >
      <ng-container *ngIf="phxTriggerTemplate; else selector">
        <ng-container *ngTemplateOutlet="phxTriggerTemplate"></ng-container>
      </ng-container>
    </div>
  </ng-template>

  <ng-template #mobileViewSelector>
    <div class="phx-date-picker-trigger" (click)="onDialogToggle(true)">
      <ng-container *ngIf="phxTriggerTemplate; else selector">
        <ng-container *ngTemplateOutlet="phxTriggerTemplate"></ng-container>
      </ng-container>
    </div>
  </ng-template>

  <!-- Overlay -->
  <phx-dropdown class="overlay" #overlay>
    <div class="phx-date-picker">
      <ng-container *ngTemplateOutlet="calendar"></ng-container>
    </div>
  </phx-dropdown>

  <phx-dialog
    *ngIf="phxDatePickerToggleEnabled && isMobileView"
    [phxFullHeight]="true"
    [phxFullWidth]="true"
    [phxBackdrop]="false"
    [phxPlacement]="'bottom'"
    [phxOpen]="phxOpen"
    (phxOpenChange)="phxOpenChange.emit($event)"
  >
    <div class="phx-date-picker-mobile-dialog">
      <div class="phx-date-picker-mobile-dialog-header">
        <button
          phx-icon-button
          [phxIcon]="ArrowLeftIcon"
          [phxIconButtonSize]="'extra-large'"
          (click)="onDialogToggle(false)"
        ></button>
        <div class="phx-date-picker-mobile-dialog-header-title">
          <span>{{ 'Date' | phxTranslate }}</span>
        </div>
        <div class="phx-date-picker-mobile-dialog-header-filler"></div>
      </div>
      <div class="phx-date-picker-mobile-dialog-content">
        <ng-container *ngTemplateOutlet="calendar"></ng-container>
      </div>
    </div>
  </phx-dialog>

  <!-- Selector -->
  <ng-template #selector>
    <div
      (click)="onClickSelector($event)"
      (keydown)="onTriggerKeydown($event)"
      (blur)="onSelectorBlur()"
      class="phx-date-picker-selector {{ selectorClasses }}"
      [attr.tabIndex]="phxDisabled ? null : 0"
      #phxElement
    >
      <!-- Content of single picker -->
      <div *ngIf="!phxIsRangeEnabled" class="phx-date-picker-single-selector">
        <ng-container *ngTemplateOutlet="prefixIcon"></ng-container>

        <ng-container *ngIf="selectedRangeHeaderLabels?.from; else placeholderTemplate">
          <span
            [class.phx-date-picker-selected]="selectedRange.start && !isDefaultSelection"
            class="phx-date-picker-label"
          >
            {{ selectedRangeHeaderLabels.from }}
          </span>
        </ng-container>

        <ng-container *ngTemplateOutlet="suffixIcon"></ng-container>
      </div>

      <!-- Content of range picker -->
      <div *ngIf="phxIsRangeEnabled" class="phx-date-picker-range-selector">
        <ng-container *ngTemplateOutlet="prefixIcon"></ng-container>

        <div class="phx-date-picker-range-labels">
          <ng-container *ngIf="selectedRangeHeaderLabels?.from; else placeholderTemplate">
            <span class="phx-date-picker-label">{{ selectedRangeHeaderLabels.from }}</span>
          </ng-container>

          <ng-container *ngIf="selectedRangeHeaderLabels?.to">
            <span #separatorElement class="phx-date-picker-separator">–</span>
            <span class="phx-date-picker-label">{{ selectedRangeHeaderLabels.to }}</span>
          </ng-container>
        </div>

        <ng-container *ngTemplateOutlet="suffixIcon"></ng-container>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-container *ngIf="phxInline">
  <ng-container *ngTemplateOutlet="calendar"></ng-container>
</ng-container>

<ng-template #calendar>
  <div class="main" cdkTrapFocus [cdkTrapFocusAutoCapture]="true" (keydown)="onKeydown($event)">
    <div class="phx-menu-header-body-wrapper">
      <phx-date-picker-menu
        *ngIf="phxIsRangeEnabled && filteredMenuItems?.length"
        #menu
        (onItemSelection)="selectDateRangeFromMenu($event)"
        phxFocusableItem
        #phxHostElement
        [menuItems]="filteredMenuItems"
        [selectedRange]="selectedRange"
      ></phx-date-picker-menu>
      <div class="phx-header-body-wrapper">
        <phx-date-picker-header
          [value]="this.currentVisibleDate"
          [config]="headerConfig"
          [mode]="mode"
          (updateCalendar)="updateCalendarView($event)"
          (updateMode)="updateMode($event)"
          phxFocusableItem
          #phxHostElement
        ></phx-date-picker-header>

        <phx-date-picker-body
          *ngIf="mode === DATE_PICKER_MODE.DATE"
          [date]="this.currentVisibleDate"
          [selectedDateRange]="selectedRange"
          [phxMinSelectableDate]="phxMinSelectableDate"
          [phxMaxSelectableDate]="phxMaxSelectableDate"
          [phxIsRangeEnabled]="phxIsRangeEnabled"
          [phxIsFullWeekSelectionEnabled]="phxIsFullWeekSelectionEnabled"
          [phxSelectableRangeLimit]="phxSelectableRangeLimit"
          [phxDatesTooltip]="phxDatesTooltip"
          [phxEnabledDates]="phxEnabledDates"
          [phxEvents]="phxEvents"
          (onDateSelection)="onDateSelection($event)"
          phxFocusableItem
          #phxHostElement
        ></phx-date-picker-body>

        <phx-month-picker-body
          *ngIf="mode === DATE_PICKER_MODE.MONTH"
          [phxYear]="currentVisibleDate?.getFullYear()"
          [phxValue]="phxIsRangeEnabled ? selectedRange : selectedRange.start"
          [phxShowSelection]="false"
          (phxValueChange)="onMonthSelection($event)"
          phxFocusableItem
          #phxHostElement
        ></phx-month-picker-body>

        <phx-year-picker-body
          *ngIf="mode === DATE_PICKER_MODE.YEAR"
          [phxVisibleDate]="currentVisibleDate"
          [phxSelectedDate]="phxIsRangeEnabled ? selectedRange : selectedRange.start"
          (phxSelectionChange)="onYearSelection($event)"
          phxFocusableItem
          #phxHostElement
        ></phx-year-picker-body>
      </div>
    </div>
    <phx-date-picker-footer
      [selectedDateLabels]="selectedRangeFooterLabels"
      [hideClearButton]="phxHideClearButton"
      [showResetButton]="showResetButton"
      [isNonDefaultRangeSelected]="isNonDefaultRangeSelected"
      (onClear)="clear()"
      (onReset)="resetToDefaultSelection()"
      phxFocusableItem
      #phxHostElement
      [skip]="
        !selectedRangeFooterLabels?.from ||
        (phxHideClearButton && !showResetButton) ||
        (showResetButton && !isNonDefaultRangeSelected)
      "
    ></phx-date-picker-footer>
  </div>
</ng-template>

<ng-template #placeholderTemplate>
  <span class="phx-date-picker-placeholder">
    {{ this.phxPlaceholder || (this.defautlPlaceholder | phxTranslate) }}
  </span>
</ng-template>

<ng-template #suffixIcon>
  <span class="phx-date-picker-suffix">
    <i phx-icon [phxIcon]="ChevronDownIcon" color="currentColor"></i>
  </span>
</ng-template>

<ng-template #prefixIcon>
  <span class="phx-date-picker-prefix">
    <i phx-icon [phxIcon]="CalendarIcon" color="currentColor"></i>
  </span>
</ng-template>

<!-- <ng-container *ngTemplateOutlet="calendar"></ng-container> -->
